export default __webpack_public_path__ + "static/hbl-round-9e675ee0f9cccc4c178f6275e30bb964.png";